var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L8.56499 1.52686C9.57784 4.26405 11.7359 6.42216 14.4731 7.43501L16 8L14.4731 8.56499C11.7359 9.57784 9.57784 11.7359 8.56499 14.4731L8 16L7.43501 14.4731C6.42216 11.7359 4.26405 9.57784 1.52686 8.56499L0 8L1.52686 7.43501C4.26405 6.42216 6.42216 4.26405 7.43501 1.52686L8 0Z",
    fill: "url(#paint0_radial_3316_121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3316_121",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8 8) rotate(90) scale(8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#FFF2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#FFDDAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5863C"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.9e86cc46.svg";
export { ForwardRef as ReactComponent };